import { motion } from "framer-motion";
import { useLang } from "@/i18n";

const BASE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_water-sports-reserve/artifacts";

const PHOTOS = [
  { src: `${BASE}/vkx0o1a0_1000132194.jpg`, cls: "md:col-span-2 md:row-span-2" },
  { src: `${BASE}/mak6mz1n_1000132412.jpg`, cls: "" },
  { src: `${BASE}/rw8zncno_1000132413.jpg`, cls: "" },
  { src: `${BASE}/j9ynhlfu_1000132193%20%281%29.jpg`, cls: "" },
  { src: `${BASE}/d1iunwsh_1000132190.jpg`, cls: "md:col-span-2" },
];

export default function Gallery() {
  const { t } = useLang();
  return (
    <section id="galleria" data-testid="gallery-section" className="bg-sand py-24 sm:py-28 grain relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal mb-4">{t.gallery.eyebrow}</p>
          <h2 className="font-serif text-3xl sm:text-5xl tracking-tight leading-[1.08] text-lake-deep">
            {t.gallery.title}
          </h2>
          <p className="mt-4 text-lake-deep/65 text-base sm:text-lg leading-relaxed">{t.gallery.sub}</p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[240px] gap-4">
          {PHOTOS.map((p, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-photo-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`relative overflow-hidden rounded-md group ${p.cls}`}
            >
              <img
                src={p.src}
                alt={t.gallery.captions[i]}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-lake-deep/85 to-transparent px-4 pb-3 pt-12">
                <span className="font-mono text-[10px] tracking-[0.25em] text-gold">0{i + 1}</span>
                <p className="text-glacier text-sm leading-snug">{t.gallery.captions[i]}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
